import { createReducer, on } from '@ngrx/store';
import { initialDownloadState } from '../constants';
import { USER_DOWNLOAD_ACTIONS } from '../actions';
import { OperationStatus } from '../types';

export const downloadReducer = createReducer(
  initialDownloadState,
  on(USER_DOWNLOAD_ACTIONS.initiateDownload, (state) => ({
    ...state,
    status: 'initiated' as OperationStatus,
  })),
  on(USER_DOWNLOAD_ACTIONS.downloadStarted, (state, { status }) => ({
    ...state,
    status,
  })),
  on(USER_DOWNLOAD_ACTIONS.downloadSuccess, (state, { fileName, status }) => ({
    ...state,
    fileName,
    status,
  })),
  on(
    USER_DOWNLOAD_ACTIONS.downloadFailure,
    (state, { errorMessage, fileName, status }) => ({
      ...state,
      errorMessage,
      fileName,
      status,
    }),
  ),
  on(USER_DOWNLOAD_ACTIONS.openDownloadConfirmationDialog, (state) => ({
    ...state,
    isDialogOpen: true,
  })),
  on(
    USER_DOWNLOAD_ACTIONS.downloadDialogConfirmed,
    USER_DOWNLOAD_ACTIONS.downloadDialogDismissed,
    (state) => ({
      ...state,
      isDialogOpen: false,
    }),
  ),
  on(
    USER_DOWNLOAD_ACTIONS.onLoadDocumentDownloadsSuccess,
    (state, { downloadsData }) => ({
      ...state,
      downloadsData: { ...downloadsData },
    }),
  ),
);
